import injectStores from "components/RootStore/injectStores";
import { ScheduleGridHeaderCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";
import { Tooltip } from "components/Tooltip";
import RootStore from "stores/RootStore";
import { RouterStore } from "stores/RouterStore";
import ServiceStore from "stores/ServiceStore";

interface HardwareScheduleRightHeaderCellProps
  extends ScheduleGridHeaderCellProps {
  currentHeader: {
    key: string | number;
    title: string;
  };
  routerStore?: RouterStore;
  jobStore?: ServiceStore;
  rootStore?: RootStore;
}

interface CurrentClient {
  shortName: string;
  name: string;
}

const HardwareScheduleRightHeaderCell = injectStores(
  (props: HardwareScheduleRightHeaderCellProps) => {
    const routerStore = props.routerStore;
    const jobStore = props.rootStore.jobStore as ServiceStore;
    const { currentHeader } = props;

    if (!jobStore.entities) {
      return (
        <div
          style={{
            border: "1px solid #eee",
            ...props.style,
            ...props.styles,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <b
            style={{ cursor: "pointer" }}
            onClick={() => {
              routerStore.goTo("ProjectDashboard", {
                projectId: currentHeader.key,
              });
            }}
          >
            Client ID: {currentHeader?.title}
          </b>
        </div>
      );
    }

    const currentClient = jobStore.entities.find(
      (i) => i.jobNumber === currentHeader.key
    ) as unknown as CurrentClient;

    return (
      <div
        style={{
          border: "1px solid #eee",
          ...props.style,
          ...props.styles,
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Tooltip title="Navigate to Job Dashboard">
          <b
            style={{ cursor: "pointer" }}
            onClick={() => {
              routerStore.goTo("JobDashboard", {
                jobNumber: currentHeader.key,
              });
            }}
          >
            {currentClient?.shortName
              ? currentClient.shortName
              : currentClient?.name || `Client ${currentHeader.key}`}
          </b>
        </Tooltip>
      </div>
    );
  }
);

export default HardwareScheduleRightHeaderCell;
